import { h, VNode, Fragment } from 'preact';
import FeedbackForm from '@components/organisms/feedback-form/feedback-form';
import FeedbackButton from '@components/atoms/feedback-button/feedback-button';
import { signal } from '@preact/signals';

const isOpen = signal(false);

export const closeWidget = (): void => {
  isOpen.value = false;
};

const Widget = (): VNode => {
  return (
    <Fragment>
      <FeedbackButton
        className={'btn-open'}
        isOpen={isOpen.value}
        onClick={() => (isOpen.value = !isOpen.value)}
      ></FeedbackButton>
      {isOpen.value && <FeedbackForm />}
    </Fragment>
  );
};

export default Widget;
